import React from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { usePrivy } from '@privy-io/react-auth';
import { useUserContext } from '@providers/UserProvider';
import { SolanaConnect, SolanaSignIn } from '@components/SolanaConnect';
import { shortenAddress } from '@utils/shorten';
import { TextLink } from '@components/Link';
import { useSolUserContext } from '@providers/SolUserProvider';
import { SignInButton } from '@components/SignInButton';
import { AddressEmoji } from '@components/AddressEmoji';
import { Button } from '@components/Button';
import { isEmail } from '@utils/address';

export const EthConnectOrSignIn = (props: {
  full?: boolean;
  showAddressIfConnected?: boolean;
  showCreateWalletIfMissing?: boolean;
}) => {
  const { user } = useUserContext();

  if (props.showCreateWalletIfMissing && ((user && !user.address) || isEmail(user?.address)))
    return <ConnectOrCreateWallet />;

  if (user?.address) return <AddressEmoji address={user.address} />;
  return <SignInButton full={props.full} />;
};

export const SolConnectOrSignIn = (props: { full?: boolean; showAddressIfConnected?: boolean }) => {
  const { user } = useUserContext();
  const { publicKey } = useWallet();

  const address = publicKey?.toString();
  const signedInWithSolana = address && address === user?.address;

  return (
    <>
      {!address ? (
        <SolanaConnect full={props.full} />
      ) : !signedInWithSolana ? (
        <SolanaSignIn full={props.full} />
      ) : props.showAddressIfConnected ? (
        <AddressDisconnect address={address} />
      ) : null}
    </>
  );
};

function AddressDisconnect(props: { address?: string }) {
  const { disconnect } = useSolUserContext();

  return (
    <div className="flex justify-between">
      Connected as {shortenAddress(props.address)}{' '}
      <TextLink onClick={disconnect}>Disconnect</TextLink>
    </div>
  );
}

export function ConnectOrSignIn() {
  return (
    <div className="mx-auto flex max-w-[190px] flex-col items-center justify-center space-y-4">
      <EthConnectOrSignIn full />
      {/* <SolConnectOrSignIn full /> */}
    </div>
  );
}

export function ConnectOrCreateWallet() {
  const { createWallet, linkWallet } = usePrivy();

  return (
    <div className="flex space-x-2">
      <Button size="xs" color="white" onClick={linkWallet}>
        Connect Wallet
      </Button>
      <Button size="xs" color="white" onClick={createWallet}>
        Create Wallet
      </Button>
    </div>
  );
}
